import request from "@/utils/request";

// 获取首页数据
export function getHomeData(data) {
    return request({
        url: "/match/match/getByDomain",
        method: "post",
        data
    });
}

// 获取学校信息
export function getSchoolData(data) {
    return request({
        url: "/match/match/getSchoolByDomain",
        method: "post",
        data
    });
}

// 获取赛段
export function getTimerShaft(data) {
    return request({
        url: "/match/timerShaft/list",
        method: "post",
        data
    });
}

// 获取时间
export function getTimer(params) {
    return request({
        url: "/support/time/getCurrentTime",
        method: "get"
    });
}

//获取赛事锦囊
export function getMatchVideo(data){
    return request({
        url:'/match/matchVideo/list',
        method:'post',
        data
    })
}

//下载
export function getDownLoad(data){
    return request({
        url:'support/download/download',
        method:'post',
        data
    })
}


//更改下载名称
export function downName(data){
    return request({
        url:`/support/download/download`,
        method:'get',
        params:data
    })
}

//优秀作品展示
export function getDistinctionItemByMatchId(data){
    return request({
        url:`/match/distinctionItem/getDistinctionItemByMatchId`,
        method:'get',
        params:data
    }) 
}

//查询作品详情
export function distinctionItem(data) {
	return request ({
		url: '/match/distinctionItem/' + data,
		method: 'get'
    });
}
//视频转码
export function testMediaProcess(data) {
	return request({
		url: 'support/customForm/testMediaProcess',
		method: 'post',
		data
	})
}

//转码进度
export function testMediaStatus(data) {
	return request({
		url: `support/upYun/testMediaStatus/${data}`,
		method: 'get'
	})
}

/**
 *  河南省赛抽签验证码接口
 * @param { } mobile 
 * @returns 
 */
export function sendVerifySms(mobile) {
	return request({
		url: `/match/henan/createValidCode/${mobile}`,
		method: 'get'
	})
}

/**
 *  河南省赛抽签验证验证码
 * @param {*} mobileAndCode 
 * @returns 
 */
export  function VerifySms(mobileAndCode) {
	return request({
		url: `/match/henan/validCode/${mobileAndCode}`,
		method: 'get'
	})
}
/**
 *  获取用户信息
 * @param {*} mobile 
 * @returns 
 */
export  function iteminfo(mobile) {
	return request({
		url: `/match/henan/iteminfo/${mobile}`,
		method: 'get'
	})
}




// WEBPACK FOOTER //
// ./src/api/home.js